import axios from 'axios';
const BASE_URL = 'api/prices/';
const MongoID = require('mongoose').Types.ObjectId;
import { getTempId } from '../../models/common';
import _ from 'lodash';

/*
  Вспомогательные функции (общая логика стора)
*/
function changeMaterialsOrder(state, id1, id2) {
  let ind1 = state.curPrice.materials.findIndex(x => x._id == id1);
  let ind2 = state.curPrice.materials.findIndex(x => x._id == id2);
  if (ind1 != -1 && ind2 != -1) {
    let elem1 = state.curPrice.materials[ind1];
    let elem2 = state.curPrice.materials[ind2];
    state.curPrice.materials.splice(ind1, 1, elem2);
    state.curPrice.materials.splice(ind2, 1, elem1);
  }
}

function changeServicesOrder(state, id1, id2) {
  let ind1 = state.curPrice.services.findIndex(x => x._id == id1);
  let ind2 = state.curPrice.services.findIndex(x => x._id == id2);
  if (ind1 != -1 && ind2 != -1) {
    let elem1 = state.curPrice.services[ind1];
    let elem2 = state.curPrice.services[ind2];
    state.curPrice.services.splice(ind1, 1, elem2);
    state.curPrice.services.splice(ind2, 1, elem1);
  }
}

function changeServicesBlocksOrder(state, block1, block2) {
  let indexes = [];
  for (let service of [...block1, ...block2]) {
    indexes.push(state.curPrice.services.findIndex(x => x._id == service._id));
  }
  //alert(JSON.stringify(indexes));
  let curIndex = 0;
  for (let service of block2) {
    state.curPrice.services.splice(indexes[curIndex], 1, service);
    curIndex++;
  }
  for (let service of block1) {
    state.curPrice.services.splice(indexes[curIndex], 1, service);
    curIndex++;
  }
}

function getServicesStructure(state, category, stage) {
  let res = [];
  for (let service of state.curPrice.services.filter(
    item => (!category || item.categoryName == category) && (!stage || item.stages.includes(stage)))) 
  {
    let categoryExists = false;
    for (let category of res) {
      if (service.categoryName == category.name) {
        categoryExists = true;
        let subCategoryExists = false;
        for (let subCategory of category.subCategories) {
          if (service.subCategoryName == subCategory.name) {
            subCategoryExists = true;
            subCategory.services.push(service);
            break;
          }
        }
        if (!subCategoryExists) category.subCategories.push({
          name: service.subCategoryName,
          services: [service]
        });
        break;
      }
    }
    if (!categoryExists) res.push({
      name: service.categoryName,
      subCategories: [
        {
          name: service.subCategoryName,
          services: [service]
        }
      ]
    });
  }
  return res;
}

function normalizeService(service) {
  service.name = service.name.trim();
  service.description = service.description.trim();
  service.categoryName = service.categoryName.trim().toUpperCase();
  service.subCategoryName = service.subCategoryName.trim().toLowerCase();
  if (service.subCategoryName.length > 0) {
    service.subCategoryName = service.subCategoryName.substr(0, 1).toUpperCase() + service.subCategoryName.substr(1);
  }
  return service;
}

function normalizeMaterial(material) {
  if (material.name) material.name = material.name.trim();
  if (material.description) material.description = material.description.trim();
  if (material.shopCode) material.shopCode = material.shopCode.trim();
  if (material.brand) material.brand = material.brand.trim().toLowerCase();
  if (material.brand && material.brand.length > 0) {
    material.brand = material.brand.substr(0, 1).toUpperCase() + material.brand.substr(1);
  }
  return material;
}

let exports = {};
exports.namespaced = true;

exports.state = () => ({
  allPrices: [],
  curPrice: null,
  curPriceVersionId: getTempId(),
  curPriceChanged: false,
  loading: {
    list: 0,
    single: 0,
    create: 0,
    update: 0,
    delete: 0
  },
  objectParams: [
    {
      text: 'Площадь пола (м2)',
      value: 'floor_square'
    },
    {
      text: 'Площадь стен (м2)',
      value: 'walls_square'
    },
    {
      text: 'Площадь потолка (м2)',
      value: 'ceiling_square'
    },
    {
      text: 'Периметр пола (мп)',
      value: 'floor_perimeter'
    },
    {
      text: 'Периметр потолка (мп)',
      value: 'ceiling_perimeter'
    },
    {
      text: 'Длина откосов под отделку (мп)',
      value: 'slopes_length'
    },
    {
      text: 'Длина подоконников (мп)',
      value: 'windowsill_length'
    },
    {
      text: 'Число электроточек (шт)',
      value: 'electric_points_count'
    },
    {
      text: 'Число сантехнических точек (шт)',
      value: 'water_points_count'
    },
  ]
});

exports.getters = {
  loadingList: state => state.loading.list != 0,
  loadingSingle: state => state.loading.single != 0,
  loadingCreate: state => state.loading.create != 0,
  loadingUpdate: state => state.loading.update != 0,
  loadingDelete: state => state.loading.delete != 0,
  pricesSelectData: state => state.allPrices.map(x => ({
    text: `${x.name} (${x.owner.fullName})`,
    value: x._id
  })),
  // Этапы работ
  stages: state => state.curPrice.stages.map((x, i) => ({
    text: `${i}. ${x.name}`,
    value: x._id
  })),
  getStageById: state => id => state.curPrice ? state.curPrice.stages.find(x => x._id == id) : null,
  indexedStages: state => state.curPrice.stages.map((val, index) => ({...val, index})),
  // Категории материалов
  materialCategories: state => state.curPrice.materialCategories,
  getMaterialCategoryById: state => id => state.curPrice ? state.curPrice.materialCategories.find(x => x._id == id) : null,
  unitNames: state => {
    let names = new Set();
    state.curPrice.materialCategories.forEach(elem => { if (elem.unitName) names.add(elem.unitName) });
    state.curPrice.materials.forEach(elem => { if (elem.unitName) names.add(elem.unitName) });
    state.curPrice.services.forEach(elem => { if (elem.unitName) names.add(elem.unitName) });
    return Array.from(names);
  },
  // Материалы
  materials: state => state.curPrice.materials.map(item => ({
    ...item,
    categoryName: state.curPrice.materialCategories.find(x => x._id == item.category).name,
    units: item.unitName == item.productUnitName ? item.unitName : `${item.productUnitName} (${item.productUnitSize} ${item.unitName})`
  })),
  getMaterialById: state => id => state.curPrice ? state.curPrice.materials.find(x => x._id == id) : null,
  materialBrands: state => Array.from(new Set(state.curPrice.materials.map(x => x.brand))).filter(x => Boolean(x)),
  materialShops: state => Array.from(new Set(state.curPrice.materials.map(x => x.shop))).filter(x => Boolean(x)),
  services: state => state.curPrice.services.map(item => ({
    ...item
  })),
  // Работы
  servicesStructure: state => (category, stage) => getServicesStructure(state, category, stage),
  getServiceById: state => id => state.curPrice ? state.curPrice.services.find(x => x._id == id) : null,
  servicesCategories: state => Array.from(new Set(state.curPrice.services.map(x => x.categoryName))),
  servicesSubCategories: state => categoryName => Array.from(
    new Set(state.curPrice.services.filter(x => x.categoryName == categoryName).map(x => x.subCategoryName))),
  materialLinks: state => ([
    ...state.curPrice.materialCategories.filter(x => Boolean(x.unitName)).map(x => ({
      _id: x._id,
      linkName: `КАТЕГОРИЯ: ${x.name}`,
      unitName: x.unitName,
      isCategory: true,
      expensePerUnit: 1
    })),
    ...state.curPrice.materials.map(x => ({
      _id: x._id,
      linkName: x.name,
      unitName: x.unitName,
      isCategory: false,
      expensePerUnit: 1
    })),
  ]),
};

exports.mutations = {
  SET_ALL_PRICES(state, prices) {
    state.allPrices = prices;
  },
  SET_CUR_PRICE(state, price) {
    state.curPrice = price;
    state.curPriceVersionId = getTempId();
    state.curPriceChanged = false;
  },
  SET_LOADING_STATUS(state, action) {
    state.loading[action]++;
  },
  REMOVE_LOADING_STATUS(state, action) {
    state.loading[action]--;
  },
  UPDATED_ON_SERVER(state) {
    state.curPriceChanged = false;
  },

  // Мутации, связанные с текущим прайс-листом
  SET_PRICE_NAME(state, name) {
    state.curPrice.name = name;
    state.curPriceChanged = true;
  },

  // МУТАЦИИ: Этапы работ
  CREATE_STAGE(state, name) {
    state.curPrice.stages.push({
      _id: String(new MongoID()),
      name: name
    });
    state.curPriceChanged = true;
  },
  DELETE_STAGE(state, id) {
    state.curPrice.stages.splice(state.curPrice.stages.findIndex(x => x._id == id), 1);
    state.curPrice.services.forEach(item => {
      item.stages = item.stages.filter(x => x._id != id);
    });
    state.curPriceChanged = true;
  },
  SET_STAGE_NAME(state, { id, name }) {
    state.curPrice.stages.find(x => x._id == id).name = name;
    state.curPriceChanged = true;
  },
  DOWN_STAGE(state, id) {
    let curIndex = state.curPrice.stages.findIndex(x => x._id == id);
    if (curIndex < state.curPrice.stages.length - 1) {
      let curElem = state.curPrice.stages[curIndex];
      let nextElem = state.curPrice.stages[curIndex + 1];
      state.curPrice.stages.splice(curIndex, 1, nextElem);
      state.curPrice.stages.splice(curIndex + 1, 1, curElem);
    }
    state.curPriceChanged = true;
  },
  UP_STAGE(state, id) {
    let curIndex = state.curPrice.stages.findIndex(x => x._id == id);
    if (curIndex > 0) {
      let curElem = state.curPrice.stages[curIndex];
      let prevElem = state.curPrice.stages[curIndex - 1];
      state.curPrice.stages.splice(curIndex, 1, prevElem);
      state.curPrice.stages.splice(curIndex - 1, 1, curElem);
    }
    state.curPriceChanged = true;
  },

  // МУТАЦИИ: Категории Материалов
  CREATE_MATERIAL_CATEGORY(state, category) {
    state.curPrice.materialCategories.push({
      _id: String(new MongoID()),
      ...category
    });
    state.curPriceChanged = true;
  },
  DELETE_MATERIAL_CATEGORY(state, id) {
    state.curPrice.materialCategories.splice(state.curPrice.materialCategories.findIndex(x => x._id == id), 1);
    state.curPrice.materials = state.curPrice.materials.filter(x => x.category != id);
    /*state.curPrice.services.forEach(item => {
      item.materialCategories = item.materialCategories.filter(x => x._id != id);
    });*/
    state.curPriceChanged = true;
  },
  UPDATE_MATERIAL_CATEGORY(state, category) {
    let index = state.curPrice.materialCategories.findIndex(x => x._id == category._id);
    if (category.unitName) {
      state.curPrice.materials.filter(x => x.category == category._id).forEach(item => {
        item.unitName = category.unitName;
      });
    }
    state.curPrice.materialCategories.splice(index, 1, category);
    state.curPriceChanged = true;
  },

  // МУТАЦИИ: Сущности Материалов
  CREATE_MATERIAL(state, material) {
    normalizeMaterial(material);
    let ind = state.curPrice.materials.findIndex(x => x.name == material.name);
    if (ind != -1) throw {
      message: 'Материал с таким названием уже существует.'
    };
    state.curPrice.materials.push({
      _id: String(new MongoID()),
      ...material
    });
    state.curPriceChanged = true;
  },
  UPDATE_MATERIAL(state, material) {
    normalizeMaterial(material);
    let ind = state.curPrice.materials.findIndex(x => (x.name == material.name) && (x._id != material._id));
    if (ind != -1) throw {
      message: 'Материал с таким названием уже существует.'
    };
    let index = state.curPrice.materials.findIndex(x => x._id == material._id);
    state.curPrice.materials.splice(index, 1, material);
    state.curPriceChanged = true;
  },
  UPDATE_MATERIAL_PRICE(state, { id, newPrice }) {
    let material = state.curPrice.materials.find(x => x._id == id);
    material.pricePerUnit = newPrice;
    state.curPriceChanged = true;
  },
  DELETE_MATERIAL(state, id) {
    state.curPrice.materials.splice(state.curPrice.materials.findIndex(x => x._id == id), 1);
    state.curPrice.services.forEach(item => {
      item.materials = item.materials.filter(x => x._id != id);
    });  
    state.curPriceChanged = true;
  },
  DOWN_MATERIAL(state, id) {
    let material = state.curPrice.materials.find(x => x._id == id);
    let catMaterials = state.curPrice.materials.filter(x => x.category == material.category);
    let curIndex = catMaterials.findIndex(x => x._id == id);
    if (curIndex < catMaterials.length - 1) {
      changeMaterialsOrder(state, id, catMaterials[curIndex + 1]._id);
    }
    state.curPriceChanged = true;
  },
  UP_MATERIAL(state, id) {
    let material = state.curPrice.materials.find(x => x._id == id);
    let catMaterials = state.curPrice.materials.filter(x => x.category == material.category);
    let curIndex = catMaterials.findIndex(x => x._id == id);
    if (curIndex > 0) {
      changeMaterialsOrder(state, id, catMaterials[curIndex - 1]._id);
    }
    state.curPriceChanged = true;
  },
  // Мутации: Сущности Работ
  CREATE_SERVICE(state, service) {
    normalizeService(service);
    let ind = state.curPrice.services.findIndex(x => x.name.toLowerCase() == service.name.toLowerCase());
    if (ind != -1) throw {
      message: 'Работа с таким именем уже существует.'
    }
    state.curPrice.services.push({
      _id: String(new MongoID()),
      ...service
    });
    state.curPriceChanged = true;
  },
  UPDATE_SERVICE(state, service) {
    normalizeService(service);
    let ind = state.curPrice.services.findIndex(x => (x.name == service.name) && (x._id != service._id));
    if (ind != -1) throw {
      message: 'Работа с таким названием уже существует.'
    };
    let index = state.curPrice.services.findIndex(x => x._id == service._id);
    state.curPrice.services.splice(index, 1, service);
    //state.curPrice.services[index] = service;
    state.curPriceChanged = true;
  },
  UPDATE_SERVICE_PRICE(state, { id, newPrice }) {
    let service = state.curPrice.services.find(x => x._id == id);
    service.pricePerUnit = newPrice;
    state.curPriceChanged = true;
  },
  DELETE_SERVICE(state, id) {
    state.curPrice.services.splice(state.curPrice.services.findIndex(x => x._id == id), 1);
    state.curPriceChanged = true;
  },
  DOWN_SERVICE(state, id) {
    let service = state.curPrice.services.find(x => x._id == id);
    let catServices = state.curPrice.services.filter(x => 
      x.categoryName == service.categoryName && x.subCategoryName == service.subCategoryName);
    let curIndex = catServices.findIndex(x => x._id == id);
    if (curIndex < catServices.length - 1) {
      changeServicesOrder(state, id, catServices[curIndex + 1]._id);
    }
    state.curPriceChanged = true;
  },
  UP_SERVICE(state, id) {
    let service = state.curPrice.services.find(x => x._id == id);
    let catServices = state.curPrice.services.filter(x => 
      x.categoryName == service.categoryName && x.subCategoryName == service.subCategoryName);
    let curIndex = catServices.findIndex(x => x._id == id);
    if (curIndex > 0) {
      changeServicesOrder(state, id, catServices[curIndex - 1]._id);
    }
    state.curPriceChanged = true;
  },
  DOWN_SERVICES_BLOCK(state, { category, subCategory }) {
    let block1 = state.curPrice.services.filter(x => 
      x.categoryName == category && (!subCategory || x.subCategoryName == subCategory));
    let structure = getServicesStructure(state);
    let catIndex = structure.findIndex(x => x.name == category);
    if (subCategory) {
      let subCatIndex = structure[catIndex].subCategories.findIndex(x => x.name == subCategory);
      if (subCatIndex < structure[catIndex].subCategories.length - 1) {
        let block2 = state.curPrice.services.filter(x => 
          x.categoryName == category && x.subCategoryName == structure[catIndex].subCategories[subCatIndex + 1].name);
        changeServicesBlocksOrder(state, block1, block2);
      }
    } else {
      if (catIndex < structure.length -1) {
        let block2 = state.curPrice.services.filter(x => x.categoryName == structure[catIndex + 1].name);
        changeServicesBlocksOrder(state, block1, block2);
      }
    }
    state.curPriceChanged = true;
  },
  UP_SERVICES_BLOCK(state, { category, subCategory }) {
    let block1 = state.curPrice.services.filter(x => 
      x.categoryName == category && (!subCategory || x.subCategoryName == subCategory));
    let structure = getServicesStructure(state);
    let catIndex = structure.findIndex(x => x.name == category);
    if (subCategory) {
      let subCatIndex = structure[catIndex].subCategories.findIndex(x => x.name == subCategory);
      if (subCatIndex > 0) {
        let block2 = state.curPrice.services.filter(x => 
          x.categoryName == category && x.subCategoryName == structure[catIndex].subCategories[subCatIndex - 1].name);
        changeServicesBlocksOrder(state, block2, block1);
      }
    } else {
      if (catIndex > 0) {
        let block2 = state.curPrice.services.filter(x => x.categoryName == structure[catIndex - 1].name);
        changeServicesBlocksOrder(state, block2, block1);
      }
    }
    state.curPriceChanged = true;
  },
  

};

exports.actions = {
  async loadList({ commit, dispatch, state }) {
    commit('SET_LOADING_STATUS', 'list');
    try {
      let res = await axios.get(BASE_URL);
      commit('SET_ALL_PRICES', res.data);
      if (!state.curPrice && res.data.length > 0) {
        await dispatch('loadSingle', res.data[0]._id);
      }
    } catch(err) {
      //alert(JSON.stringify(err));
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('REMOVE_LOADING_STATUS', 'list');
    }
  },

  async loadSingle({ commit, dispatch }, id) {
    commit('SET_LOADING_STATUS', 'single');
    try {
      let res = await axios.get(BASE_URL + id);
      commit('SET_CUR_PRICE', res.data);
    } catch(err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('REMOVE_LOADING_STATUS', 'single');
    }
  },

  async loadCustomerPrice({ commit, dispatch }, customerId) {
    try {
      let res = await axios.get(BASE_URL + 'lk/' + customerId);
      return res.data;
    } catch(err) {
      dispatch('showMessage', err.response.data.message, { root: true });

    } finally {
      
    }
  },

  async create({ commit, dispatch }, price) {
    commit('SET_LOADING_STATUS', 'create');
    try {
      let res = await axios.post(BASE_URL, price);
      await dispatch('loadSingle', res.data.price._id);
      await dispatch('loadList');
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'create');
    }
  },

  async update({ commit, dispatch, state}) {
    commit('SET_LOADING_STATUS', 'update');
    try {
      state.curPrice.materials.forEach(x => normalizeMaterial(x));
      let res = await axios.patch(BASE_URL, state.curPrice);
      commit('UPDATED_ON_SERVER');
      await dispatch('loadList');
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'update');
    }
  },

  async delete({ commit, dispatch, state }, id) {
    commit('SET_LOADING_STATUS', 'delete');
    try {
      let res = await axios.delete(BASE_URL + id);
      if (state.curPrice._id == id) {
        commit('SET_CUR_PRICE', null);
      }
      await dispatch('loadList');
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'delete');
    }
  },
};

export default exports;


